import Cookies from 'js-cookie'

export const CAMPAIGN_ID = 'campaignid_capture'

export const SF_ACCOUNT_ID = 'sfacid'
export const SF_LEAD_ID = 'sflcid'
export const SF_QUOTE_ID = 'sfqcid'
export const SF_OPPORTUNITY_ID = 'sfocid'

export const AFFILIATE_ID = 'affiliate_id'
export const TCPA_AGREEMENT = 'tcpa_agreement'

export function applyCookies ({
  payload = {},
  getCookieValue = getCookie,
  prefer = true
} = {}) {
  const cookies = {
    externalLeadId: getCookieValue(SF_LEAD_ID),
    externalAccountId: getCookieValue(SF_ACCOUNT_ID),
    externalQuoteId: getCookieValue(SF_QUOTE_ID),
    externalOpportunityId: getCookieValue(SF_OPPORTUNITY_ID),
    source: getCookieValue(CAMPAIGN_ID)
  }
  if (prefer) {
    return { ...payload, ...cookies }
  }
  return { ...cookies, ...payload }
}

export function getCookie (name, fallback = '') {
  return Cookies.get(name) || fallback
}

export function setCookie (name, value) {
  Cookies.set(name, (value || '').toString())
  return value
}
